import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import SellWebsite from "../views/WebsiteSell.vue";
// import Alstarpro from "../views/Alstar-pro.vue";
import mdbproject from "../views/MovieDatabase.vue";
import NotFound from "../components/PortfolioNotFound.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: "Portfolio | Putra Hidayat Arifin" },
  },
  {
    path: "/Website",
    name: "sellingwebsite",
    component: SellWebsite,
    meta: { title: "Portfolio | Website Template" },
  },
  {
    path: "/Mdb",
    name: "moviedatabase",
    component: mdbproject,
    meta: { title: "Portfolio | Movie Database Project" },
  },
  {
    path: "*",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
